/* eslint-disable max-len */
export const GET_DAILY_DIARY_TOILET_TRAINING_WITHOUT_RECORDS = 'GET_DAILY_DIARY_TOILET_TRAINING_WITHOUT_RECORDS'
export const GET_DAILY_DIARY_TOILET_TRAINING_WITHOUT_RECORDS_SUCCESS = 'GET_DAILY_DIARY_TOILET_TRAINING_WITHOUT_RECORDS_SUCCESS'
export const GET_DAILY_DIARY_TOILET_TRAINING_WITHOUT_RECORDS_FAILED = 'GET_DAILY_DIARY_TOILET_TRAINING_WITHOUT_RECORDS_FAILED'

export const CLEAR_DAILY_DIARY_TOILET_TRAINING_WITHOUT_RECORDS = 'CLEAR_DAILY_DIARY_TOILET_TRAINING_WITHOUT_RECORDS'
